import { PaymentStoreBase } from "@app/services/stores/shared/PaymentStoreBase";
import { Injectable } from "@angular/core";

@Injectable()
export class PaymentEditStore extends PaymentStoreBase {
    static $inject = []
    constructor() {
        super("hoapass_paymentEdit_", sessionStorage)
    }
}
